window.locales = window.locales || {};window.locales.am = window.locales.am || {};window.locales.am.findFriendsBox = window.locales.am.findFriendsBox || {};window.locales.am.findFriendsBox = {...window.locales.am.findFriendsBox, ...{
    "heading": "በ {institutionName} ውስጥ ጓደኞችን ያግኙ",
    "content": "ለስራ ባልደረቦች እና ጓደኞች የተመራቂዎች አውታረ መረብን ያስሱ።",
    "button_view_students_and_alumni": "ተማሪዎችን እና የቀድሞ ተማሪዎችን ይመልከቱ"
}
};window.locales.ar = window.locales.ar || {};window.locales.ar.findFriendsBox = window.locales.ar.findFriendsBox || {};window.locales.ar.findFriendsBox = {...window.locales.ar.findFriendsBox, ...{
    "heading": "ابحث عن أصدقاء في {institutionName}",
    "content": "تصفح شبكة الخريجين للبحث عن الزملاء والأصدقاء.",
    "button_view_students_and_alumni": "عرض الطلاب والخريجين"
}
};window.locales.en = window.locales.en || {};window.locales.en.findFriendsBox = window.locales.en.findFriendsBox || {};window.locales.en.findFriendsBox = {...window.locales.en.findFriendsBox, ...{
    "heading": "Find Friends in {institutionName}",
    "content": "Browse the alumni network for colleagues and friends.",
    "button_view_students_and_alumni": "View Students and Alumni"
}
};window.locales.es = window.locales.es || {};window.locales.es.findFriendsBox = window.locales.es.findFriendsBox || {};window.locales.es.findFriendsBox = {...window.locales.es.findFriendsBox, ...{
    "heading": "Encuentra amigos en {institutionName}",
    "content": "Explore la red de ex alumnos para encontrar colegas y amigos.",
    "button_view_students_and_alumni": "Ver estudiantes y exalumnos"
}
};window.locales.it = window.locales.it || {};window.locales.it.findFriendsBox = window.locales.it.findFriendsBox || {};window.locales.it.findFriendsBox = {...window.locales.it.findFriendsBox, ...{
    "heading": "Trova amici in {institutionName}",
    "content": "Esplora la rete degli ex studenti per trovare colleghi e amici.",
    "button_view_students_and_alumni": "Visualizza studenti ed ex studenti"
}
};window.locales.zh = window.locales.zh || {};window.locales.zh.findFriendsBox = window.locales.zh.findFriendsBox || {};window.locales.zh.findFriendsBox = {...window.locales.zh.findFriendsBox, ...{
    "heading": "在{institutionName}中查找好友",
    "content": "浏览校友网络以查找同事和朋友。",
    "button_view_students_and_alumni": "查看学生和校友"
}
};